var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('common-header'),_c('div',{staticClass:"complete"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('router-link',{attrs:{"to":"/login"}},[_c('span',[_vm._v("ログインページはこちら")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }